const _require = require('@truqc/content-path'),
  getValue = _require.getValue,
  getContentValues = _require.getContentValues;
const _require2 = require('../lib/evaluateSource'),
  evaluateSource = _require2.evaluateSource;

/**
  * @function evalute - evaluate getVariableBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const name = await evaluateSource(source.name, content, parentContentPath, transientContext, nativeFunctions);
  if (typeof name !== 'string') {
    return undefined;
  }
  if (name.length > 0 && name.includes('*')) {
    return getContentValues(name, transientContext);
  }
  return name.length ? getValue(name, transientContext) : transientContext;
};
module.exports = {
  evaluate
};